import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'
import storage from 'redux-persist/lib/storage'
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist'
import speakerReducer from '@/store/slices/speakersSlice'
import categoyReducer from '@/store/slices/categorySlice'
import speakerTypesReducer from '@/store/slices/speakerTypesSlice'
import headReducer from '@/store/slices/headSlice'
import errorReducer from '@/store/slices/errorSlice'

import { persistStore } from 'redux-persist'

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
}

const reducer = combineReducers({
  speakers: speakerReducer,
  category: categoyReducer,
  speakerType: speakerTypesReducer,
  head: headReducer,
  error: errorReducer,
})

const persistedReducer = persistReducer(persistConfig, reducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})
export const persistor = persistStore(store)
